var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('h1',[_vm._v("Hours")]),_c('form',{on:{"submit":function($event){$event.preventDefault();return _vm.runReport.apply(null, arguments)}}},[_c('Options'),_c('GroupBy'),_c('Fields'),_c('Results')],1)])}
var staticRenderFns = []

export { render, staticRenderFns }